var map = {
	"./legal/pages/review": [
		53590,
		[
			2089,
			1922,
			894,
			9774,
			2482,
			8547,
			5702,
			2954,
			3348,
			804,
			2842,
			1192,
			1540,
			8861,
			7000,
			5184,
			4755,
			1829,
			7648,
			5655
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5488;
module.exports = webpackAsyncContext;